import { z } from 'zod';

import { generalConfig } from '@sola/config/lib/getters.ts';

export const LeadResponse = z.object({
  success: z.boolean(),
});
export type LeadResponse = z.infer<typeof LeadResponse>;

const locationBase = z.object({
  accountId: z.string().optional(),
  globalId: z.string().optional(),
  churchName: z.string(),
  churchAddress: z.string(),
  churchCity: z.string(),
  churchState: z.string(),
  churchPostal: z.string(),
  churchCountry: z.string().optional(),
  churchWebsite: z.string().optional(),
});

export const nameFields = {
  firstName: z
    .string()
    .transform((v) => v.trim())
    .pipe(z.string().max(generalConfig.leadForms.firstNameMaxLength)),
  lastName: z
    .string()
    .transform((v) => v.trim())
    .pipe(z.string().max(generalConfig.leadForms.lastNameMaxLength)),
} as const;
/** LEAD FORMS */
export const LeadContact = z
  .object({
    contactId: z.string().optional(),
    email: z.string().email(),
    phone: z.string().optional(),
    role: z.string().optional(),
    sourceCode: z.string().optional(),
    subscriptionCode: z.string().optional(),
  })
  .safeExtend(nameFields);
export type LeadContact = z.infer<typeof LeadContact>;

export const LeadChurch = locationBase.extend({
  memberSize: z.string().optional(),
  sourceCode: z.string().optional(),
});
export type LeadChurch = z.infer<typeof LeadChurch>;

export interface LeadRequest {
  leadType: string;
  contact: LeadContact;
  church: LeadChurch;
  comments?: string;
}

/** EVENT FORMS */
export const LeadHost = LeadContact.extend({
  accountId: z.string().optional(),
  globalId: z.string().optional(),
  isPastor: z.boolean().optional(),
  withKids: z.boolean().optional(),
  shippingAddress: z.string().optional(),
  shippingCity: z.string().optional(),
  shippingState: z.string().optional(),
  shippingPostal: z.string().optional(),
  items: z.string().array().optional(),
  // deprecating in favor of Items
  tShirtSize: z.string().optional(),
  tShirtSizeKids: z.string().optional(),
  tShirtSizeCoHost: z.string().optional(),
});
export type LeadHost = z.infer<typeof LeadHost>;

export const LeadEvent = locationBase.extend({
  eventDate: z.string().optional(),
  audienceSize: z.string().optional(),
});
export type LeadEvent = z.infer<typeof LeadEvent>;

export interface EventRequest {
  leadType: string;
  sourceCode: string;
  host: LeadHost;
  event?: LeadEvent;
}

/** COMPASSION SUNDAY FORMS */
export enum CompassionSundayType {
  Planning = 'planning',
  Registration = 'registration',
}

export type CSLeadHost = z.infer<typeof LeadHost>;
export type CSLeadEvent = z.infer<typeof LeadEvent>;
export interface CompassionSundayRequest {
  csType: CompassionSundayType;
  sourceCode: string;
  host: CSLeadHost;
  event?: CSLeadEvent;
}
